import { render, staticRenderFns } from "./BetterFoundation.vue?vue&type=template&id=00fccc75&scoped=true"
import script from "./BetterFoundation.vue?vue&type=script&lang=js"
export * from "./BetterFoundation.vue?vue&type=script&lang=js"
import style0 from "./BetterFoundation.vue?vue&type=style&index=0&id=00fccc75&prod&lang=scss"
import style1 from "./BetterFoundation.vue?vue&type=style&index=1&id=00fccc75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fccc75",
  null
  
)

export default component.exports